import BaseApiClient from '@/plugins/apis/v2/base-api-client';
export default (function (context) {
    BaseApiClient.setContext(context);
});
